import type { FaireProductEntity } from "../../entity_types/product";

export const p_gmjwbj3sae: FaireProductEntity = {
  token: "p_gmjwbj3sae",
  type: "product",
  name: "Glass Match Cloche | Olive Green",
  brandToken: "b_b19tidse3g",
  brandName: "BOTANICA",
  imageUrl:
    "https://cdn.faire.com/fastly/6a6286cdd5b5a7d442d934066c8c17dae68e24f9fb01e4c1c8d89eae0a3a0999.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6b92ff51fb196141f7c91ca64eb7da9247f3a6625a9fd344e46793510861eb52.jpeg",
    "https://cdn.faire.com/fastly/ef2ea5f80ca97ef50f727b8f8d1e7485eef04088c9c1593ee8271638195c01c7.jpeg",
    "https://cdn.faire.com/fastly/814dca52cf0a7e5908d8829d061a34447e3b72623fc98b84e9e1e69c0589ef46.jpeg",
    "https://cdn.faire.com/fastly/167c7546d1f0c01f3c30595ebcf014931f4810ba7ce5245f5dbc78522771176b.jpeg",
  ],
  priceDollars: 16,
  description:
    'Versatile, functional & stylish, our match cloches make the perfect accompaniment to your favorite Botanica candle. Designed in chic colorways, they enhance any color-coordinated merchandising display. Each handblown glass vessel contains 120 white-tipped, wooden safety matches along with a handy honeycomb striker hidden on the backside. Our label is easily removable, making these eye-catching, colorful pieces ready for your mantle right out of the box.\n\n• Glass Color: Olive Green\n• 120 White-Tipped Safety Matches\n• Cloche Size: 7" Height x 3.125" Diameter \n• Cork Stopper & Striker \n• Removable Label\n\n• This product is only available to the 48 contiguous United States & Canada via Ground Delivery.\n\n\n\n\nKeywords for your SEO:\nMatchsticks, match holder, match striker, vintage matchbooks, holiday gift ideas, holiday gift, hostess gift, candle, candle accessories, kitsch, unique gifts, mantle decor, mantle decorations, fireplace matches, fireplace decor, home decor, spring, summer, fall, autumn, winter, gift sets, wedding gifts, wedding',
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:36:27.876Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
